/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_Reading_Group_TitleInputs */

const en_why_listening_zotero_reading_group_title = /** @type {(inputs: Why_Listening_Zotero_Reading_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folding in crowded cells`)
};

const es_why_listening_zotero_reading_group_title = /** @type {(inputs: Why_Listening_Zotero_Reading_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plegamiento en células abarrotadas`)
};

/**
* | output |
* | --- |
* | "Folding in crowded cells" |
*
* @param {Why_Listening_Zotero_Reading_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_reading_group_title = /** @type {((inputs?: Why_Listening_Zotero_Reading_Group_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_Reading_Group_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_reading_group_title(inputs)
	return en_why_listening_zotero_reading_group_title(inputs)
});